import '@babel/polyfill';

// Load jQuery first for any other dependencies
import jquery from 'jquery';
import Vue from 'vue';
import Vuetify from 'vuetify'
import '../stylus/main.styl';
import 'isomorphic-unfetch';
import VTooltip from 'v-tooltip';
import axios from 'axios';
import Vue2Filtres from 'vue2-filters';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vuex from 'vuex'
import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import store from 'Root/stores/store';
import Btn from 'Components/Vuetify/Btn';
import FileInput from 'Components/Vuetify/FileInput';
import VuexDataLoader from 'Components/VuexDataLoader';

window.$ = jquery;

require('./global-helpers');
require('./localStorage');
require('./sessions'); // Make sure this is after localstorage.js

// Setup Sentry to listen to this project

Sentry.init({
    dsn: process.env.MIX_SENTRY_VUE_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
        new Integrations.Vue({
            Vue,
            attachProps: true,
        }),
    ],
});

// SET UP GRAPHQL STUFF

let clientGenerator = function(uri) {
    return {
        link: createHttpLink({
            uri: uri,
            credentials: 'same-origin',
            // useGETForQueries: true,
        }),
        cache: new InMemoryCache({
            addTypename: true
        }),
        connectToDevTools: true,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: 'cache-and-network'
            },
            query: {
                fetchPolicy: 'cache-and-network'
            }
        }
    }
};

const defaultClient = new ApolloClient(clientGenerator('/graphql'));

var vueInstanceData = {
    menu: false,
    cart: false,
    toolbarDense: false,
    admin_drawer: false,
    mini: true,
    snackbar: false,
    snackbar_text: '',
    snackbar_color: '',
    snackbar_timeout: 0,
    toolbar_fixed: true,
    api_is_loading: false,
    show_cookie_consent: false,
    toggle_api_loading: true,
    isMobile: false
};

const apolloProvider = new VueApollo({
    clients: {
        public: new ApolloClient(clientGenerator(`/graphql/public`)),
        admin: new ApolloClient(clientGenerator(`/graphql/admin`)),
        me: new ApolloClient(clientGenerator(`/graphql/me`)),
        decorator: new ApolloClient(clientGenerator(`/graphql/decorator`)),
        dropship: new ApolloClient(clientGenerator(`/graphql/dropship`)),
        api: new ApolloClient(clientGenerator(`/graphql/api`)),
        employee: new ApolloClient(clientGenerator(`/graphql/employee`)),
    },
    defaultClient: defaultClient,
    watchLoading (isLoading, countModifier) {
        if (isLoading) {
            return vueInstanceData.api_is_loading = true;
        }
        return vueInstanceData.api_is_loading = false;
    },
});

// Bootstrap into axios package to enable / disable spinner automatically on request

axios.interceptors.request.use(function (config) {
    if (vueInstanceData.toggle_api_loading) {
        vueInstanceData.api_is_loading = true;
    }
    return config;
}, function (error) {
    if (vueInstanceData.toggle_api_loading) {
        vueInstanceData.api_is_loading = false;
    }
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    // Do something with response data
    if (vueInstanceData.toggle_api_loading) {
        vueInstanceData.api_is_loading = false;
    }
    return response;
}, function (error) {
    // Do something with response error
    if (vueInstanceData.toggle_api_loading) {
        vueInstanceData.api_is_loading = false;
    }
    return Promise.reject(error);
});

// Setup Vuetify settings

Vue.use(Vuetify, {
    theme: {
        primary: '#00aedb',
        secondary: '#79aec8',
        accent: '#0288D1',
        // error: '',
        // info: '',
        // success: '',
        // warning: ''
    },
    iconfont: 'fa',
    icons: {
        sort: 'fal fa-arrow-up',
        expand: 'fal fa-chevron-down'
    }
});
Vue.use(VueApollo);
Vue.use(Vuex);
Vue.use(VTooltip);
Vue.use(Vue2Filtres);
Vue.prototype.$http = axios;

Vue.component('btn', Btn);
Vue.component('file-input', FileInput);
Vue.component('date-range-picker', () => import('Components/Vuetify/DateRangePicker'));

const app = new Vue({
    el: '#app',
    store: new Vuex.Store(store),
    apolloProvider,
    data() {
        return vueInstanceData;
    },
    methods: {
        menuClicked() {
            this.menu = !this.menu;
        },
        cartClicked() {
            this.cart = !this.cart;
        },
        adminToolbarClick() {
            this.admin_drawer = !this.admin_drawer
        },
        customerConsentsToCookie() {
            window.swell.setCookie('cookie_consent', 1);
            this.show_cookie_consent = false;
        },
        denseMainToolbar() {
            this.toolbarDense = window.scrollY > 3
        },
        checkIfMobile() {
            if (window.innerWidth < 600) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }
        }
    },
    created() {
        this.checkIfMobile();

        // If higher than v-navigation-drawer mobile breakpoint res
        if (window.$(window).width() > 1264) {
            this.admin_drawer = true
        }
    },
    mounted() {
        this.$store.commit('Cart/setShopperSessionId', window.swell.getCookie('shopper_session_id'));

        if (!window.swell.getCookie('cookie_consent')) {
            this.show_cookie_consent = true;
        }

        if (swell.browserIsOldIE()) {
            alert("To get the most optimal experience, please use either Chrome, Firefox, Safari or Microsoft Edge.")
        }

        window.addEventListener('resize', () => {
            this.checkIfMobile();
        })
    },
    components: {
        'artisan-command-gui': () => import('Components/ArtisanCommandGui'),
        'sales-chart': () => import('Components/SalesChart'),
        'admin-dashboard': () => import('Components/AdminDashboard'),
        'admin-dashboard-total-sales': () => import('Components/AdminDashboardTotalSales'),
        'coupon-usages-chart': () => import('Components/CouponUsagesChart'),
        'vuex-data-loader': VuexDataLoader,
        'customer-application': () => import('components/CustomerApplication'),
        'application-success': () => import('Components/ApplicationSuccess'),
        'application-list-page': () => import('Components/ApplicationListPage'),
        'site-settings': () => import('Components/SiteSettings'),
        'loading-state': () => import('Components/LoadingState'),
        'edit-application': () => import('Components/EditApplication'),
        'user-list': () => import('Components/UserList.vue'),
        'edit-product-page': () => import('Components/EditProductPage.vue'),
        'roles-admin-page': () => import('Components/RolesAdminPage.vue'),
        'custom-login-page': () => import('Components/CustomLoginPage.vue'),
        'shipping-zones': () => import('Components/ShippingZones'),
        'multiple-files-upload': () => import('Components/MultipleFilesUpload.vue'),
        'email-list-page': () => import('Components/MailListPage.vue'),
        'decorators-page': () => import('Components/DecoratorsPage.vue'),
        'shipping-zone-by-state': () => import('Components/ShippingZoneByState.vue'),
        'decorator-by-zip': () => import('Components/DecoratorByZip.vue'),
        'create-new-product-page': () => import('Components/CreateNewProductPage.vue'),
        'product-list-page': () => import('Components/ProductListPage.vue'),
        'product-categories-page': () => import('Components/ProductCategoryListPage/index.vue'),
        'product-category-edit-page': () => import('Components/ProductCategoryEditPage.vue'),
        'product-categories': () => import('Components/ProductCategoryListPage/CategoryList.vue'),
        'shop-page': () => import('Components/ShopPage.vue'),
        'shop-page-filter': () => import('Components/ShopPageFilter'),
        'cart-icon': () => import('Components/CartIcon.vue'),
        'cart-page': () => import('Components/CartPage'),
        'checkout-page': () => import('Components/CheckoutPage'),
        'product-detail-page': () => import('Components/ProductDetailPage.vue'),
        'create-new-attribute-page': () => import('Components/CreateNewAttributePage.vue'),
        'edit-attribute-page': () => import('Components/EditAttributePage.vue'),
        'create-attribute-set-page': () => import('Components/CreateAttributeSetPage'),
        'product-attributes-list-page': () => import('Components/ProductAttributesListPage'),
        'currency-list-page': () => import('Components/CurrencyListPage'),
        'create-new-currency-page': () => import('Components/CreateNewCurrencyPage'),
        'edit-currency-page': () => import('Components/EditCurrencyPage'),
        'product-site-options': () => import('Components/ProductSiteOptions'),
        'attribute-set-list-page': () => import('Components/AttributeSetListPage'),
        'edit-attribute-set': () => import('Components/EditAttributeSet'),
        'customer-group-list-page': () => import('Components/CustomerGroupListPage'),
        'create-customer-group': () => import('Components/CreateCustomerGroup'),
        'admin-sites-page': () => import('Components/AdminSitesPage'),
        'admin-sites-edit-page': () => import('Components/AdminSitesEditPage'),
        'companies-list-page': () => import('Components/CompaniesListPage'),
        'company-edit-page': () => import('Components/CompanyEditPage'),
        'create-company-page': () => import('Components/CreateCompanyPage'),
        'warehouse-list-page': () => import('Components/WarehouseListPage'),
        'create-warehouse-page': () => import('Components/CreateWarehousePage'),
        'update-warehouse-page': () => import('Components/UpdateWarehouse'),
        'state-warehouse-page': () => import('Components/StateWarehousePage'),
        'warehouse-decorators-page': ()=> import('Components/WarehouseDecoratorsPage'),
        'create-user-page': () => import('Components/CreateUserPage'),
        'edit-user-page': () => import('Components/EditUserPage'),
        'decorator-dashboard': () => import('Components/DecoratorDashboard'),
        'sales-order-list-page': () => import('Components/SalesOrderListPage'),
        'edit-order-page': () => import('Components/EditOrderPage'),
        'create-order-page': () => import('Components/CreateOrderPage'),
        'customer-order-view': () => import('Components/CustomerOrderView'),
        'product-uploader': () => import('Components/ProductUploader'),
        'product-exporter': () => import('Components/ProductExporter'),
        'logs-list-page': () => import('Components/LogsListPage'),
        'failed-queue-jobs': () => import('Components/FailedQueueJobs'),
        'decorator-order-view': () => import('Components/DecoratorOrderView'),
        'links-unlimited-list-page': () => import('Components/LinksUnlimitedListPage'),
        'account-dashboard' : () => import('Components/AccountDashboard'),
        'employee-account-dashboard' : () => import('Components/EmployeeAccountDashboard'),
        'account-menu' : () => import('Components/AccountMenu'),
        'customer-profile' : () => import('Components/CustomerProfile'),
        'saved-projects' : () => import('Components/SavedProjects'),
        'dashboard-application-summary' : () => import('Components/DashboardApplicationSummary'),
        'coupon-list-page': () => import('Components/CouponListPage'),
        'create-coupon': () => import('Components/CreateCoupon'),
        'edit-coupon': () => import('Components/EditCoupon'),
        'site-selector': () => import('Components/SiteSelector'),
        'dropship-dashboard': () => import('Components/Dropship/Dashboard'),
        'admin-dashboard-application-chart': () => import('Components/AdminDashboardApplicationChart'),
        'old-site-order-list-page': () => import('Components/OldSiteOrderListPage'),
        'old-site-order-page': () => import('Components/OldSiteOrderPage'),

        'old-site-lop-customer-list-page': () => import('Components/OldSiteLopCustomerListPage'),
        'old-site-lop-customer-page': () => import('Components/OldSiteLopCustomerPage'),
        'old-site-lop-order-list-page': () => import('Components/OldSiteLopOrderListPage'),
        'old-site-lop-order-page': () => import('Components/OldSiteLopOrderPage'),
        'old-site-lop-application-list-page': () => import('Components/OldSiteLopApplicationListPage'),
        'old-site-lop-application-page': () => import('Components/OldSiteLopApplicationPage'),

        'site-nav-builder': () => import('Components/SiteNavBuilder/SiteNavBuilder'),
        'walmart-pulse-order-list-page': () => import('Components/WalmartPulseOrderListPage'),
        'walmart-pulse-batches-list-page': () => import('Components/WalmartPulseBatchesListPage'),
    }
});

window.app = app;
